import { render, staticRenderFns } from "./ylkt4.vue?vue&type=template&id=492fae46&scoped=true&"
import script from "./ylkt4.vue?vue&type=script&lang=js&"
export * from "./ylkt4.vue?vue&type=script&lang=js&"
import style0 from "./ylkt4.vue?vue&type=style&index=0&id=492fae46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492fae46",
  null
  
)

export default component.exports